import { useEffect } from 'react'
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import anearApi from '../Api/AnearApi'
import ROUTES from '../../routesConfig'
import * as logger from 'loglevel'

const appAttrs = app => {
  return {
    zoneId:       app.zone.id,
    appId:        app.app.id,
    shortName:    app.app.attributes['short-name'],
    longName:     app.app.attributes['long-name'],
    latestAppVersion: app.app.attributes['latest-app-version'],
    iconUrl:      app.app.attributes['icon-url'],
    description:  app.app.attributes['description'],
    requiresGeoLocation: app.eventRequiresGeoLocation()
  }
}

const CreateEventBySlugPage = () => {
  const { appSlug } = useParams()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    let cancelled = false

    const findAppAndRedirect = async () => {
      try {
        const apps = await anearApi.globalPlayableApps()

        if (cancelled) return

        // Filter out apps that are not user-selectable (embeddable-only child apps).
        // user_selectable defaults to true, so only exclude if explicitly false
        const selectableApps = apps.filter(app => {
          const userSelectable = app.app.attributes['user-selectable'] ??
                                 app.app.attributes.user_selectable ??
                                 true // Default to true for backward compatibility
          return userSelectable !== false
        })

        // Find app by slug
        const app = selectableApps.find(playableApp =>
          playableApp.app.attributes.slug === appSlug
        )

        if (!app) {
          logger.warn(`App with slug '${appSlug}' not found or not user-selectable, redirecting to /apps`)
          navigate(ROUTES.APPS, { replace: true })
          return
        }

        const playableApp = appAttrs(app)
        const launchFrom = location.state?.launchFrom || location.state?.from || null

        // Redirect to the canonical create-event URL, using the human-readable
        // app slug while still passing the resolved playable app in state.
        navigate(ROUTES.CREATE_EVENT(appSlug), {
          state: {
            playableApp,
            ...(launchFrom ? { launchFrom } : {})
          },
          replace: true
        })
      } catch (err) {
        logger.error(`Error finding app by slug '${appSlug}':`, err)
        if (!cancelled) {
          navigate(ROUTES.APPS, { replace: true })
        }
      }
    }

    findAppAndRedirect()
    return () => { cancelled = true }
  }, [appSlug, navigate, location.state])

  // Return null while loading/redirecting
  return null
}

export default CreateEventBySlugPage

